
// // import React, { useState } from 'react';
// // import { motion } from "framer-motion";
// // import { MdEmail, MdLocationOn, MdPhoneInTalk } from "react-icons/md";
// // import { IoCallSharp } from "react-icons/io5";
// // import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
// // import { FiSend } from "react-icons/fi";
// // import emailjs from 'emailjs-com';
// // import { toast, ToastContainer } from 'react-toastify';
// // import 'react-toastify/dist/ReactToastify.css';

// // const Contact = () => {
// //     const [formData, setFormData] = useState({
// //         name: '',
// //         email: '',
// //         message: ''
// //     });

// //     const handleChange = (e) => {
// //         setFormData({ ...formData, [e.target.name]: e.target.value });
// //     };

// //     const handleSubmit = (e) => {
// //         e.preventDefault();

// //         // EmailJS integration with your new Service ID
// //         emailjs.send(
// //             'service_jqvaw1k',
// //             'template_iqkg6yd',
// //             formData,
// //             'cEHIFlFveDcaflpnE'
// //         )
// //             .then((result) => {
// //                 toast.success("Message Sent Successfully! 🚀");
// //                 setFormData({ name: '', email: '', message: '' });
// //             }, (error) => {
// //                 console.error("EmailJS Error:", error);
// //                 toast.error("Failed to send message. Please try again.");
// //             });
// //     };

// //     return (
// //         <div style={s.pageWrapper}>
// //             <style>{globalCSS}</style>
// //             <ToastContainer theme="dark" />

// //             <div style={{ ...s.orb, ...s.orbTopRight }}></div>
// //             <div style={{ ...s.orb, ...s.orbBottomLeft }}></div>

// //             <div style={s.container}>
// //                 <div style={s.headerSection}>
// //                     <h1 style={s.mainTitle}>Contact Us</h1>
// //                     <p style={s.subTitle}>Any question or remarks? Just write us a message!</p>
// //                 </div>

// //                 <motion.div
// //                     initial={{ opacity: 0, y: 30 }}
// //                     animate={{ opacity: 1, y: 0 }}
// //                     transition={{ duration: 0.8 }}
// //                     style={s.glassCard}
// //                 >
// //                     {/* LEFT PANEL: CONTENT SECTION */}
// //                     <div style={s.infoSide}>
// //                         <div>
// //                             <h2 style={s.cardTitle}>Contact Information</h2>
// //                             <p style={{ color: '#555', fontSize: '14px', marginTop: '-30px', marginBottom: '40px' }}>Say something to start a live chat!</p>
// //                         </div>

// //                         <div style={s.contactInfoList}>
// //                             <div style={s.infoItem}>
// //                                 <MdEmail size={24} color="#fff" />
// //                                 <div>
// //                                     <b style={s.label}>Email</b>
// //                                     <p style={s.val}>info@galaxyerpsoftware.com</p>
// //                                 </div>
// //                             </div>
// //                             <div style={s.infoItem}>
// //                                 <MdPhoneInTalk size={24} color="#fff" />
// //                                 <div>
// //                                     <b style={s.label}>Office Number</b>
// //                                     <p style={s.val}>+91-9638177750</p>
// //                                     <p style={s.val}>+91-8128061833</p>
// //                                 </div>
// //                             </div>
// //                             <div style={s.infoItem}>
// //                                 <MdLocationOn size={24} color="#fff" />
// //                                 <div>
// //                                     <b style={s.label}>Office Address</b>
// //                                     <p style={s.val}>410, The Boulevard, Pratham Circle Opp Pal RTO, Pal, Green City Rd, Adajan, Surat, Gujarat 395009.</p>
// //                                 </div>
// //                             </div>
// //                             <div style={s.infoItem}>
// //                                 <IoCallSharp size={24} color="#fff" />
// //                                 <div>
// //                                     <b style={s.label}>Business Enquiry</b>
// //                                     <p style={s.val}>+91-9924577750</p>
// //                                     <p style={s.val}>sales@galaxyerpsoftware.com</p>
// //                                 </div>
// //                             </div>
// //                         </div>

// //                         <div style={s.socialContainer}>
// //                             <a href="https://www.facebook.com/people/Galaxy-ERP/61557637277831/" target="_blank" rel="noopener noreferrer" className="soc-btn fb" title="Facebook"><FaFacebookF /></a>
// //                             <a href="https://www.instagram.com/galaxyerpsoftwarepvtltd/" target="_blank" rel="noopener noreferrer" className="soc-btn ig" title="Instagram"><FaInstagram /></a>
// //                             <a href="https://www.linkedin.com/company/galaxy-erp-software-private-limited/" target="_blank" rel="noopener noreferrer" className="soc-btn li" title="LinkedIn"><FaLinkedinIn /></a>
// //                         </div>
// //                     </div>

// //                     {/* RIGHT PANEL: FORM SECTION */}
// //                     <div style={s.formSide}>
// //                         <form onSubmit={handleSubmit} style={s.formLayout}>
// //                             <div style={s.inputGroup}>
// //                                 <label style={s.fieldLabel}>Name</label>
// //                                 <input
// //                                     type="text"
// //                                     name="name"
// //                                     value={formData.name}
// //                                     onChange={handleChange}
// //                                     style={s.lineInput}
// //                                     placeholder="Enter your full name"
// //                                     required
// //                                 />
// //                             </div>

// //                             <div style={s.inputGroup}>
// //                                 <label style={s.fieldLabel}>Email Address</label>
// //                                 <input
// //                                     type="email"
// //                                     name="email"
// //                                     value={formData.email}
// //                                     onChange={handleChange}
// //                                     style={s.lineInput}
// //                                     placeholder="Enter your email address"
// //                                     required
// //                                 />
// //                             </div>

// //                             <div style={{ gridColumn: 'span 1', marginTop: '15px' }}>
// //                                 <label style={s.fieldLabel}>Message</label>
// //                                 <textarea
// //                                     name="message"
// //                                     value={formData.message}
// //                                     onChange={handleChange}
// //                                     style={s.messageArea}
// //                                     placeholder="Enter your message here..."
// //                                     required
// //                                 ></textarea>
// //                             </div>

// //                             <div style={{ gridColumn: 'span 1', textAlign: 'right', position: 'relative', marginTop: '60px' }}>
// //                                 <button type="submit" className="submit-plane-btn" style={s.submitButton}>
// //                                     Send Message
// //                                 </button>

// //                                 <div style={s.planeWrap}>
// //                                     <svg width="120" height="80" viewBox="0 0 120 80" style={s.dashSvg}>
// //                                         <path
// //                                             d="M0,60 C30,60 80,50 110,10"
// //                                             fill="none"
// //                                             stroke="#00d2ff"
// //                                             strokeWidth="2"
// //                                             strokeDasharray="6,6"
// //                                             opacity="0.5"
// //                                         />
// //                                     </svg>
// //                                     <div style={s.planeCircle}>
// //                                         <FiSend style={s.planeIcon} />
// //                                     </div>
// //                                 </div>
// //                                 <div style={s.dotsPattern}></div>
// //                             </div>
// //                         </form>
// //                     </div>
// //                 </motion.div>

// //                 {/* Map Section - Dark Theme with White Info Box */}
// //                 <div style={s.mapContainer}>
// //                     <iframe
// //                         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.123!2d72.78!3d21.18!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04df6b3f81ead%3A0x3265271ba545962f!2sGalaxyERP%20Software%20Private%20Limited!5e0!3m2!1sen!2sin!4v1705840000000!5m2!1sen!2sin"
// //                         width="100%"
// //                         height="450"
// //                         style={{
// //                             border: 0,
// //                             borderRadius: '25px',
// //                             filter: ' invert(90%) hue-rotate(180deg)'
// //                         }}
// //                         allowFullScreen=""
// //                         loading="lazy"
// //                         referrerPolicy="no-referrer-when-downgrade"
// //                         title="Galaxy ERP Office Location"
// //                     ></iframe>

// //                     <style>{`
// //         .map-container iframe {
// //             filter: none !important;
// //         }
// //     `}</style>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // const s = {
// //     pageWrapper: { backgroundColor: '#000', minHeight: '100vh', padding: '100px 20px', position: 'relative', overflowX: 'hidden', color: '#fff', fontFamily: "'Poppins', sans-serif" },
// //     orb: { position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', filter: 'blur(80px)', opacity: '0.25', zIndex: 1 },
// //     orbTopRight: { background: '#00d2ff', top: '-5%', right: '-5%' },
// //     orbBottomLeft: { background: '#8E2DE2', bottom: '5%', left: '-5%' },
// //     container: { maxWidth: '1150px', margin: '0 auto', position: 'relative', zIndex: 10 },
// //     headerSection: { textAlign: 'center', marginBottom: '60px' },
// //     mainTitle: { fontSize: '40px', fontWeight: '800', margin: 0, letterSpacing: '-0.5px',fontFamily:"'Inter',sans-serif" },
// //     subTitle: { color: '#aaa', fontSize: '16px', marginTop: '20px',   fontfamily:"'Inter',sans-serif", },
// //     glassCard: { display: 'flex', flexWrap: 'wrap', background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(30px)', borderRadius: '30px', border: '1px solid rgba(255, 255, 255, 0.1)', overflow: 'hidden' },
// //     infoSide: { flex: '1', minWidth: '350px', padding: '50px', background: '#000', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRight: '1px solid #111' },
// //     cardTitle: { fontSize: '28px', fontWeight: '700', marginBottom: '40px' },
// //     contactInfoList: { display: 'flex', flexDirection: 'column', gap: '30px' },
// //     infoItem: { display: 'flex', alignItems: 'flex-start', gap: '20px' },
// //     label: { display: 'block', fontSize: '14px',
// //         //  color: '#fff',
// //         color: '#00d2ff',
// //           marginBottom: '2px' },
// //     val: { color: '#888', fontSize: '14px', margin: 0, lineHeight: '1.5' },
// //     socialContainer: { display: 'flex', gap: '15px', marginTop: '50px' },
// //     formSide: { flex: '1.5', minWidth: '350px', padding: '50px', position: 'relative' },
// //     formLayout: { display: 'grid', gridTemplateColumns: '1fr', gap: '40px' },
// //     inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
// //     fieldLabel: { fontSize: '12px', fontWeight: '600', color: '#aaa', textTransform: 'uppercase', letterSpacing: '1px' },
// //     lineInput: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none' },
// //     messageArea: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none', width: '100%', height: '80px', resize: 'none' },
// //     submitButton: { padding: '14px 45px', borderRadius: '8px', border: '1px solid #333', background: '#000', color: '#fff', fontSize: '15px', fontWeight: '700', cursor: 'pointer', transition: '0.3s', zIndex: 5, position: 'relative'},
// //     planeWrap: {
// //         position: 'absolute',
// //         right: '-40px',
// //         bottom: '-30px',
// //         width: '150px',
// //         height: '100px',
// //         pointerEvents: 'none',
// //         zIndex: 10
// //     },
// //     planeCircle: {
// //         position: 'absolute',
// //         top: '10px',
// //         right: '10px',
// //         width: '45px',
// //         height: '45px',
// //         borderRadius: '50%',
// //         background: 'rgba(0,210,255,0.15)',
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'center',
// //         transform: 'rotate(-10deg)',
// //         boxShadow: '0 0 15px rgba(0,210,255,0.2)'
// //     },
// //     dashSvg: {
// //         position: 'absolute',
// //         top: '30px',
// //         right: '35px',
// //         opacity: 0.6,
// //         overflow: 'visible'
// //     },
// //     planeIcon: { fontSize: '24px', color: '#00d2ff' },
// //     dotsPattern: { position: 'absolute', bottom: '-20px', right: '20px', width: '100px', height: '40px', background: 'radial-gradient(#222 1.5px, transparent 1.5px)', backgroundSize: '12px 12px', opacity: '0.6' },
// //     mapContainer: { marginTop: '50px', borderRadius: '30px', overflow: 'hidden', border: '1px solid #111' }
// // };

// // const globalCSS = `
// //     .soc-btn { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; text-decoration: none; transition: 0.3s; font-size: 18px; }
// //     .fb { background: #1877F2; }
// //     .ig { background: linear-gradient(45deg, #f09433, #dc2743, #bc1888); }
// //     .li { background: #0077B5; }
// //     .soc-btn:hover { transform: translateY(-5px); opacity: 0.8; }
// //     input:focus, textarea:focus { border-bottom-color: #00d2ff !important; }
// //     .submit-plane-btn:hover { background: #fff !important; color: #000 !important; }
// //     @media (max-width: 900px) {
// //         .planeWrap, .dotsPattern { display: none !important; }
// //     }
// // `;

// // export default Contact;
import React, { useState, useEffect } from 'react';
import { MdEmail, MdLocationOn, MdPhoneInTalk } from "react-icons/md";
import { IoCallSharp } from "react-icons/io5";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import emailjs from 'emailjs-com';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });

    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 100);
        return () => clearTimeout(t);
    }, []);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.send('service_dasimh4', 'template_h8onwcc', formData, 'dwtNSjNe2CULnzQK-')
            .then(() => {
                toast.success("Message Sent Successfully! 🚀");
                setFormData({ name: '', email: '', message: '' });
            }, (error) => {
                console.error("EmailJS Error:", error);
                toast.error("Failed to send message. Please try again.");
            });
    };

    const fadeUp = (delay = 0) => ({
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(30px)',
        transition: `opacity 0.9s cubic-bezier(0.25,0.1,0.25,1) ${delay}s, transform 0.9s cubic-bezier(0.25,0.1,0.25,1) ${delay}s`,
    });

    const fadeLeft = (delay = 0) => ({
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateX(0)' : 'translateX(-50px)',
        transition: `opacity 0.9s cubic-bezier(0.25,0.1,0.25,1) ${delay}s, transform 0.9s cubic-bezier(0.25,0.1,0.25,1) ${delay}s`,
    });

    const fadeRight = (delay = 0) => ({
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateX(0)' : 'translateX(50px)',
        transition: `opacity 0.9s cubic-bezier(0.25,0.1,0.25,1) ${delay}s, transform 0.9s cubic-bezier(0.25,0.1,0.25,1) ${delay}s`,
    });

    return (
        <div style={s.pageWrapper} className="contact-page-wrapper">
            <style>{globalCSS}</style>
            <ToastContainer theme="dark" />

            <div style={{ ...s.orb, ...s.orbTopRight }} />
            <div style={{ ...s.orb, ...s.orbBottomLeft }} />

            <div style={s.container}>

                {/* Header */}
                <div style={{ ...s.headerSection, ...fadeUp(0) }} className="contact-header">
                    <h1 style={s.mainTitle}>Contact Us</h1>
                    <p style={s.subTitle}>Any question or remarks? Just write us a message!</p>
                </div>

                {/* Glass Card */}
                <div style={s.glassCard} className="contact-glass-card">

                    {/* LEFT */}
                    <div style={{ ...s.infoSide, ...fadeLeft(0.15) }} className="contact-info-side">
                        <div>
                            <h2 style={s.cardTitle} className="contact-card-title">Contact Information</h2>
                            <p style={{ color: '#888', fontSize: '14px', marginTop: '-30px', marginBottom: '40px' }}>
                                Say something to start a live chat!
                            </p>
                        </div>

                        <div style={s.contactInfoList}>
                            {[
                                { Icon: MdEmail, label: "Email", content: <a href="mailto:info@galaxyerpsoftware.com" onClick={(e) => { e.preventDefault(); window.open('https://mail.google.com/mail/?view=cm&to=info@galaxyerpsoftware.com', '_blank'); }} style={{ color: '#888', textDecoration: 'none' }}>info@galaxyerpsoftware.com</a>, iconSize: 24 },
                                { Icon: MdPhoneInTalk, label: "Office Number", content: <><a href="tel:+919638177750" style={{ color: '#888', textDecoration: 'none' }}>+91-9638177750</a><br /><a href="tel:+918128061833" style={{ color: '#888', textDecoration: 'none' }}>+91-8128061833</a></>, iconSize: 24 },
                                { Icon: MdLocationOn, label: "Office Address", content: "410, The Boulevard, Pratham Circle Opp Pal RTO, Pal, Green City Rd, Adajan, Surat, Gujarat 395009.", iconSize: 38 },
                                { Icon: IoCallSharp, label: "Business Enquiry", content: <><a href="tel:+919924577750" style={{ color: '#888', textDecoration: 'none' }}>+91-9924577750</a><br /><a href="mailto:sales@galaxyerpsoftware.com" onClick={(e) => { e.preventDefault(); window.open('https://mail.google.com/mail/?view=cm&to=sales@galaxyerpsoftware.com', '_blank'); }} style={{ color: '#888', textDecoration: 'none' }}>sales@galaxyerpsoftware.com</a></>, iconSize: 24 },
                            ].map(({ Icon, label, content, iconSize }, i) => (
                                <div key={i} style={{ ...s.infoItem, ...fadeLeft(0.2 + i * 0.08) }}>
                                    <Icon size={iconSize} color="#fff" />
                                    <div>
                                        {label && <b style={s.label}>{label}</b>}
                                        <p style={s.val}>{content}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div style={{ ...s.socialContainer, ...fadeUp(0.55) }}>
                            <a href="https://www.facebook.com/people/Galaxy-ERP/61557637277831/" target="_blank" rel="noopener noreferrer" className="soc-btn fb"><FaFacebookF /></a>
                            <a href="https://www.instagram.com/galaxyerpsoftwarepvtltd/" target="_blank" rel="noopener noreferrer" className="soc-btn ig"><FaInstagram /></a>
                            <a href="https://www.linkedin.com/company/galaxy-erp-software-private-limited/" target="_blank" rel="noopener noreferrer" className="soc-btn li"><FaLinkedinIn /></a>
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div style={{ ...s.formSide, ...fadeRight(0.2) }} className="contact-form-side">
                        <form onSubmit={handleSubmit} style={s.formLayout}>
                            {[
                                { label: 'Name', name: 'name', type: 'text', placeholder: 'Enter your full name' },
                                { label: 'Email Address', name: 'email', type: 'email', placeholder: 'Enter your email address' },
                            ].map((field, i) => (
                                <div key={i} style={{ ...s.inputGroup, ...fadeUp(0.25 + i * 0.1) }}>
                                    <label style={s.fieldLabel}>{field.label}</label>
                                    <input type={field.type} name={field.name} value={formData[field.name]} onChange={handleChange} style={s.lineInput} placeholder={field.placeholder} required />
                                </div>
                            ))}

                            <div style={{ gridColumn: 'span 1', marginTop: '15px', ...fadeUp(0.45) }}>
                                <label style={s.fieldLabel}>Message</label>
                                <textarea name="message" value={formData.message} onChange={handleChange} style={s.messageArea} placeholder="Enter your message here..." required></textarea>
                            </div>

                            <div className="contact-submit-row" style={{ gridColumn: 'span 1', textAlign: 'right', position: 'relative', marginTop: '60px', ...fadeUp(0.55) }}>
                                <button type="submit" className="submit-plane-btn" style={s.submitButton}>Send Message</button>
                                <div style={s.planeWrap} className="contact-plane-wrap">
                                    <svg width="120" height="80" viewBox="0 0 120 80" style={s.dashSvg}>
                                        <path d="M0,60 C30,60 80,50 110,10" fill="none" stroke="#00d2ff" strokeWidth="2" strokeDasharray="6,6" opacity="0.5" />
                                    </svg>
                                    <div style={s.planeCircle}><FiSend style={s.planeIcon} /></div>
                                </div>
                                <div style={s.dotsPattern} className="contact-dots-pattern"></div>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Map */}
                <div style={{ ...s.mapContainer, ...fadeUp(0.3) }} className="contact-map-container">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.123!2d72.78!3d21.18!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04df6b3f81ead%3A0x3265271ba545962f!2sGalaxyERP%20Software%20Private%20Limited!5e0!3m2!1sen!2sin!4v1705840000000!5m2!1sen!2sin"
                        width="100%" height="450"
                        style={{ border: 0, borderRadius: '25px', filter: 'invert(90%) hue-rotate(180deg)' }}
                        allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                        title="Galaxy ERP Office Location"
                    />
                </div>
            </div>
        </div>
    );
};

const s = {
    pageWrapper: { backgroundColor: '#000', minHeight: '100vh', padding: '100px 20px', position: 'relative', overflowX: 'hidden', color: '#fff', fontFamily: "'Poppins', sans-serif" },
    orb: { position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', filter: 'blur(80px)', opacity: '0.25', zIndex: 1 },
    orbTopRight: { background: '#00d2ff', top: '-5%', right: '-5%' },
    orbBottomLeft: { background: '#8E2DE2', bottom: '5%', left: '-5%' },
    container: { maxWidth: '1150px', margin: '0 auto', position: 'relative', zIndex: 10 },
    headerSection: { textAlign: 'center', marginBottom: '60px' },
    mainTitle: { fontSize: '40px', fontWeight: '800', margin: 0, letterSpacing: '-0.5px', fontFamily: "'Inter',sans-serif" },
    subTitle: { color: '#aaa', fontSize: '16px', marginTop: '20px', fontFamily: "'Inter',sans-serif" },
    glassCard: { display: 'flex', flexWrap: 'wrap', background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(30px)', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.1)', overflow: 'visible' },
    infoSide: { flex: '1', minWidth: '350px', padding: '50px', background: '#000', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRight: '1px solid #111', borderRadius: '30px 0 0 30px' },
    cardTitle: { fontSize: '28px', fontWeight: '700', marginBottom: '40px' },
    contactInfoList: { display: 'flex', flexDirection: 'column', gap: '30px' },
    infoItem: { display: 'flex', alignItems: 'flex-start', gap: '20px' },
    label: { display: 'block', fontSize: '14px', color: '#00d2ff', marginBottom: '2px' },
    val: { color: '#888', fontSize: '14px', margin: 0, lineHeight: '1.5' },
    socialContainer: { display: 'flex', gap: '15px', marginTop: '50px' },
    formSide: { flex: '1.5', minWidth: '350px', padding: '50px', position: 'relative' },
    formLayout: { display: 'grid', gridTemplateColumns: '1fr', gap: '40px' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
    fieldLabel: { fontSize: '12px', fontWeight: '600', color: '#cecece', textTransform: 'uppercase', letterSpacing: '1px' },
    lineInput: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none', width: '100%', boxSizing: 'border-box' },
    messageArea: { background: 'transparent', border: 'none', borderBottom: '1px solid #333', padding: '10px 0', color: '#fff', fontSize: '16px', outline: 'none', width: '100%', height: '80px', resize: 'none', boxSizing: 'border-box', fontFamily: "'Poppins',sans-serif" },
    submitButton: { padding: '14px 45px', borderRadius: '8px', border: '1px solid #333', background: '#000', color: '#fff', fontSize: '15px', fontWeight: '700', cursor: 'pointer', transition: '0.3s', zIndex: 5, position: 'relative' },
    planeWrap: { position: 'absolute', right: '-40px', bottom: '-30px', width: '150px', height: '100px', pointerEvents: 'none', zIndex: 10 },
    planeCircle: { position: 'absolute', top: '10px', right: '10px', width: '45px', height: '45px', borderRadius: '50%', background: 'rgba(0,210,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', transform: 'rotate(-10deg)', boxShadow: '0 0 15px rgba(0,210,255,0.2)' },
    dashSvg: { position: 'absolute', top: '30px', right: '35px', opacity: 0.6, overflow: 'visible' },
    planeIcon: { fontSize: '24px', color: '#00d2ff' },
    dotsPattern: { position: 'absolute', bottom: '-20px', right: '20px', width: '100px', height: '40px', background: 'radial-gradient(#222 1.5px, transparent 1.5px)', backgroundSize: '12px 12px', opacity: '0.6' },
    mapContainer: { marginTop: '50px', borderRadius: '30px', overflow: 'hidden', border: '1px solid #111' }
};

const globalCSS = `
    .soc-btn { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #888; text-decoration: none; transition: all 0.3s; font-size: 18px; background: transparent; border: 1px solid rgba(255,255,255,0.1); }
    .soc-btn:hover { transform: translateY(-5px); }
    .fb:hover { background: #1877F2; border-color: #1877F2; color: #fff; }
    .ig:hover { background: linear-gradient(45deg,#f09433,#dc2743,#bc1888); border-color: transparent; color: #fff; }
    .li:hover { background: #0077B5; border-color: #0077B5; color: #fff; }
    input:focus, textarea:focus { border-bottom-color: #00d2ff !important; }
    .submit-plane-btn:hover { background: #fff !important; color: #000 !important; }
    @media (max-width: 900px) {
        .contact-submit-row { margin-top: 24px !important; }
        .contact-page-wrapper { padding: 90px 16px 40px !important; }
        .contact-header { margin-bottom: 24px !important; }
        .contact-glass-card { flex-direction: column !important; }
        .contact-info-side { min-width: unset !important; width: 100% !important; border-right: none !important; border-bottom: 1px solid #111 !important; border-radius: 30px 30px 0 0 !important; padding: 32px 24px !important; }
        .contact-form-side { min-width: unset !important; width: 100% !important; padding: 32px 24px 32px !important; border-radius: 0 0 30px 30px !important; overflow: visible !important; }
        .contact-plane-wrap { right: -25px !important; bottom: 5px !important; width: 90px !important; height: 70px !important; }
        .contact-dots-pattern { right: 100px !important; bottom: 20px !important; width: 60px !important; }
        .contact-map-container { margin-top: 32px !important; }
        .contact-map-container iframe { height: 300px !important; }
    }
    @media (max-width: 768px) {
        .contact-header h1 { font-size: 36px !important; }
        .contact-header p { font-size: 15px !important; margin-top: 10px !important; }
        .contact-card-title { font-size: 26px !important; }
        .submit-plane-btn { font-size: 15px !important; padding: 13px 32px !important; }
        .contact-plane-wrap { right: -25px !important; bottom: 20px !important; width: 68px !important; height: 54px !important; }
    }
    @media (max-width: 600px) {
        .contact-page-wrapper { padding: 85px 12px 32px !important; }
        .contact-header { margin-bottom: 16px !important; }
        .contact-header h1 { font-size: 32px !important; }
        .contact-info-side { padding: 24px 16px !important; border-radius: 26px 26px 0 0 !important; }
        .contact-form-side { padding: 24px 16px 50px !important; border-radius: 0 0 26px 26px !important; }
        .contact-submit-row { text-align: center !important; margin-top: 20px !important; }
        .submit-plane-btn { font-size: 15px !important; padding: 13px 0 !important; width: 100% !important; display: block !important; text-align: center !important; }
        .contact-dots-pattern { display: none !important; }
        .contact-map-container iframe { height: 250px !important; }
    }
    @media (max-width: 480px) {
        .contact-header h1 { font-size: 28px !important; }
        .contact-card-title { font-size: 22px !important; }
        .submit-plane-btn { font-size: 14px !important; }
        .contact-plane-wrap { right: -25px !important; bottom: 25px !important; width: 62px !important; height: 50px !important; }
    }
    @media (max-width: 400px) {
        .contact-page-wrapper { padding: 85px 10px 28px !important; }
        .contact-info-side { padding: 20px 14px !important; }
        .contact-form-side { padding: 20px 14px 48px !important; }
        .contact-map-container iframe { height: 220px !important; }
    }
    @media (max-width: 360px) {
        .contact-header h1 { font-size: 24px !important; }
        .contact-card-title { font-size: 20px !important; }
        .submit-plane-btn { font-size: 13px !important; }
        .contact-map-container iframe { height: 200px !important; }
    }
`;

export default Contact; 